import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {signup_template} from "../components/templates/signup_template";

declare var ko: any;
declare var page: any;

export class emailConfirmation extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected signup_template: signup_template;

    protected getModuleName(){
        return "emailConfirmation";
    }

    buildContent() : Array<Element>{

        this.signup_template = new signup_template("emailConfirmation", this.viewModel, this);
        return [this.signup_template.build()];
    }

    fillPage() : void{

        this.validateToken();

    }

    protected validateToken(){

        let token: string;

        if(token = this.getVnAppZone().app.params.token){

            this.signup_template.getTemplateViewModel().processingToken("block");

            let validateReq_url: string = '/api/access/validate/accountConfirmation/token/' + token + '/';
            let validateReq_params: Array<Array<string>> = [];

            this.XHRHdl = new XMLHttpRequestHandler(validateReq_url, validateReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.showValidateTemplate;
            this.XHRHdl.execute();
        }
    }

    protected showValidateTemplate(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.signup_template.getTemplateViewModel().processingToken("none");

                if (responseParsed.status == 200) {

                    obj.signup_template.getTemplateViewModel().accountName(responseParsed.data.accountName);
                    obj.signup_template.getTemplateViewModel().fullName(responseParsed.data.firstName + ' ' + responseParsed.data.lastName);
                    obj.signup_template.getTemplateViewModel().planId(responseParsed.data.idPlan);
                    obj.signup_template.getTemplateViewModel().signupComplete("block");
                }else if (responseParsed.status == 405) {

                    obj.signup_template.getTemplateViewModel().invalidToken("block");
                }else if (responseParsed.status == 400) {

                    obj.signup_template.getTemplateViewModel().expiredToken("block");
                }
            });
        }
    }


    public renewToken(){

        this.loadingIn(this.signup_template.builtTemplate.querySelector("#expired-token"));

        let token: string;

        if(token = this.getVnAppZone().app.params.token) {

            let expiredToken: string = '/api/access/renew/accountConfirmation/token/' + token + '/';
            let validateReq_params: Array<Array<string>> = [];

            this.XHRHdl = new XMLHttpRequestHandler(expiredToken, validateReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onRenewTokenpRequestReturn;
            this.XHRHdl.execute();
        }
    }

    protected onRenewTokenpRequestReturn(req, obj): Function {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.signup_template.getTemplateViewModel().expiredToken("none");
                obj.signup_template.getTemplateViewModel().emailSent("block");
            });

            obj.loadingOut(obj.signup_template.builtTemplate.querySelector("#expired-token"));
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/emailConfirmation.ts